var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-alert",
    _vm._b(
      { attrs: { elevation: _vm.elevation, value: _vm.value, dark: _vm.dark } },
      "v-alert",
      { ..._vm.$attrs },
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }